// components/roster/StaffFilter.jsx

const StaffFilter = ({ staffs, value, onChange }) => {
  return (
    <div className="flex items-center gap-3">
      {/* Label */}
      <span className="text-sm font-medium text-textGray">Staff:</span>

      {/* Select */}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="
          bg-dry
          border
          border-border
          text-textGray
          px-4
          py-2
          rounded
          min-w-[150px]
          focus:outline-none
          focus:ring-1
          focus:ring-yellowlight
          text-xs
        "
      >
        <option value="all">All Staff</option>

        {staffs.map((staff) => (
          <option key={staff._id} value={staff._id}>
            {staff.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StaffFilter;
